import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface CompletenessScoreProps {
  score?: number;
  size?: number;
}

const getColor = (score: number): string => {
  if (score >= 80) return "#4caf50";
  if (score >= 60) return "#ff9800";
  if (score >= 40) return "#f44336";
  return "#9e9e9e";
};

const getLabel = (score: number): string => {
  if (score >= 80) return "Great";
  if (score >= 60) return "Good";
  if (score >= 40) return "Fair";
  return "Poor";
};

export const CompletenessScore: React.FC<CompletenessScoreProps> = ({
  score,
  size = 70,
}) => {
  const normalizedScore = score ?? 50;

  const color = getColor(normalizedScore);
  const label = getLabel(normalizedScore);

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        background: "rgba(255, 255, 255, 0.95)",
        borderRadius: "50%",
        padding: "4px",
        backdropFilter: "blur(10px)",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={3}
        sx={{
          color: "#e0e0e0",
          position: "absolute",
        }}
      />
      <CircularProgress
        variant="determinate"
        value={score}
        size={size}
        thickness={3}
        sx={{
          color,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body2"
          component="div"
          sx={{
            fontWeight: "bold",
            color,
            fontSize: "0.85rem",
          }}
        >
          {score}%
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: "0.5rem", color: "text.secondary", lineHeight: 0.8 }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default CompletenessScore;
